// Deleted-event tombstones (Glitch #645, 10/27/26). The events list is read
// from a MySQL mirror that the delete does not touch until the next Airtable
// sync, so a refetch right after a delete can bring the deleted event straight
// back, and the localStorage copy of the active list can hold it across an app
// reopen. This browser remembers the host ids it deleted and hides any list row
// that points at one of them. A row matches on its own id OR on its
// "Host Event" link, because an invitee sub-task row carries the host's id there.
// Entries expire after a week: by then the mirror has caught up with the delete.

const STORAGE_KEY = "events:deleted";
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

const readAll = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const writeAll = (map) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // quota / private mode — the tombstones are a display guard only
  }
};

const pruned = (map, now) => {
  const kept = {};
  Object.entries(map).forEach(([id, at]) => {
    if (now - at < TTL_MS) kept[id] = at;
  });
  return kept;
};

const has = (map, id) => id != null && Object.prototype.hasOwnProperty.call(map, id);

export const markEventDeleted = (hostId, now = Date.now()) => {
  if (!hostId) return;
  writeAll({ ...pruned(readAll(), now), [hostId]: now });
};

export const unmarkEventDeleted = (hostId) => {
  if (!hostId) return;
  const map = readAll();
  delete map[hostId];
  writeAll(map);
};

export const withoutDeletedEvents = (rows, now = Date.now()) => {
  if (!Array.isArray(rows)) return rows;
  const deleted = pruned(readAll(), now);
  return rows.filter(
    (row) => !has(deleted, row?.id) && !has(deleted, row?.fields?.["Host Event"]?.[0])
  );
};
